import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "data-table__bulk-operations" };
import CommandButton from "./CommandButton.vue";
import { AbstractCommand } from "../services/CommandQueue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DataTableBulkOperations',
    props: {
        operations: {},
        params: { type: Function },
        buttonVariant: {}
    },
    setup(__props) {
        class BulkOperationCommand extends AbstractCommand {
            operation;
            params;
            constructor(operation, params) {
                super();
                this.operation = operation;
                this.params = params;
            }
            execute() {
                return this.operation.execute(this.params);
            }
            name() {
                return this.operation.name;
            }
            icon() {
                return this.operation.icon;
            }
            needsConfirmation() {
                return !!this.operation.needsConfirmation;
            }
            isDangerous() {
                return !!this.operation.isDangerous;
            }
        }
        const props = __props;
        const commands = props.operations.map(operation => new BulkOperationCommand(operation, props.params()));
        const buttonClasses = ['button', 'button--light'].concat(props.buttonVariant ? [] : ['button--small']);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(commands), (command, index) => {
                    return (_openBlock(), _createBlock(CommandButton, {
                        key: index,
                        command: command,
                        classes: _unref(buttonClasses)
                    }, null, 8, ["command", "classes"]));
                }), 128))
            ]));
        };
    }
});
